module.exports = __webpack_public_path__ + "static/media/about.ee04637b.jpg";